import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-consulta-bateu-pr',
  templateUrl: './consulta-bateu-pr.component.html',
  styleUrls: ['./consulta-bateu-pr.component.scss']
})
export class ConsultaBateuPrComponent implements OnInit {

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  texto = null;

  statusMsg = null;
  status = 'info';

  @Input() token = '';

  constructor() { }

  ngOnInit() {
    this.loadTxtBatida();
  }

  loadTxtBatida(){
    if( this.consulta.listaDadosBatidas==null || this.consulta.listaDadosBatidas.length==0){
      this.texto = "Nenhum registro de batida encontrado.";
      this.status = 'info';
    }else{
      this.status = 'danger';
    }
  }

}
